document.addEventListener('DOMContentLoaded', () => {
  if (!document.documentElement.classList.contains('ramon-section-v5')) return;

  const icons = {
    user: '<circle cx="12" cy="8" r="3"></circle><path d="M5.5 20a6.5 6.5 0 0 1 13 0"></path>',
    search: '<circle cx="11" cy="11" r="6"></circle><path d="m16 16 4 4M11 8v6M8 11h6"></path>',
    clipboard: '<rect x="5" y="4" width="14" height="17" rx="2"></rect><path d="M9 4.5V3h6v1.5M8 9h8M8 13h5"></path>',
    document: '<path d="M6 2h8l4 4v16H6zM14 2v5h5M9 12h6M9 16h6"></path>',
    message: '<path d="M4 5h16v11H9l-5 4z"></path><path d="M8 9h8M8 12h5"></path>',
    calculator: '<rect x="5" y="2" width="14" height="20" rx="2"></rect><path d="M8 6h8v3H8zM8 13h.01M12 13h.01M16 13h.01M8 17h.01M12 17h.01M16 17h.01"></path>',
    home: '<path d="m3 11 9-8 9 8M5 10v11h14V10M9 21v-7h6v7"></path>',
    alert: '<path d="M12 3 2.5 20h19zM12 9v5M12 17h.01"></path>',
    list: '<path d="M9 6h11M9 12h11M9 18h7M4 6h.01M4 12h.01M4 18h.01"></path>',
    mail: '<rect x="3" y="5" width="18" height="14" rx="2"></rect><path d="m4 7 8 6 8-6"></path>',
    route: '<circle cx="6" cy="18" r="2"></circle><circle cx="18" cy="6" r="2"></circle><path d="M8 18h3a3 3 0 0 0 3-3V9a3 3 0 0 1 3-3"></path>',
    form: '<path d="M6 2h9l4 4v16H6zM14 2v5h5M9 12h6M9 16h3"></path><path d="m14 17 1.5 1.5L19 15"></path>',
    key: '<circle cx="8" cy="15" r="4"></circle><path d="m11 12 8-8M16 7l2 2M14 9l2 2"></path>',
    folder: '<path d="M3 6h7l2 2h9v11H3z"></path>',
    package: '<path d="m4 7 8-4 8 4v10l-8 4-8-4zM4 7l8 4 8-4M12 11v10"></path>',
    wallet: '<path d="M4 6h14a2 2 0 0 1 2 2v11H4a2 2 0 0 1-2-2V7a3 3 0 0 1 3-3h12"></path><path d="M15 11h5v4h-5a2 2 0 0 1 0-4z"></path>',
    chart: '<path d="M4 20V10M10 20V4M16 20v-7M22 20H2"></path>',
    calendar: '<rect x="3" y="5" width="18" height="16" rx="2"></rect><path d="M7 3v4M17 3v4M3 10h18M8 14h3v3H8z"></path>',
    receipt: '<path d="M6 2h12v20l-3-2-3 2-3-2-3 2zM9 7h6M9 11h6M9 15h4"></path>',
    users: '<circle cx="9" cy="8" r="3"></circle><path d="M3 20a6 6 0 0 1 12 0M16 5a3 3 0 0 1 0 6M17 14a5 5 0 0 1 4 5"></path>',
    globe: '<circle cx="12" cy="12" r="9"></circle><path d="M3 12h18M12 3a15 15 0 0 1 0 18M12 3a15 15 0 0 0 0 18"></path>'
  };
  const iconSets = [
    ['#ramon-panel-personal .i-task-summary > li', ['user', 'search', 'clipboard', 'document', 'message', 'calculator', 'home', 'alert', 'list', 'mail', 'route', 'form', 'key', 'folder', 'package', 'wallet', 'chart', 'calendar']],
    ['#ramon-panel-autonomo .i-task-summary > li', ['calendar', 'receipt', 'calculator', 'wallet', 'chart', 'mail', 'form', 'package']],
    ['#ramon-panel-sl .i-task-summary > li', ['clipboard', 'calculator', 'users', 'globe', 'folder', 'mail', 'chart', 'package']],
    ['[data-task-group="personal"] > li', ['user', 'search', 'clipboard', 'document', 'message', 'calculator', 'home', 'alert', 'list', 'mail', 'route', 'form', 'key', 'folder', 'package', 'wallet', 'chart', 'calendar']],
    ['[data-task-group="autonomo"] > li', ['calendar', 'receipt', 'calculator', 'wallet', 'chart', 'mail', 'form', 'calendar', 'alert', 'package']],
    ['[data-task-group="sl"] > li', ['clipboard', 'calculator', 'users', 'globe', 'folder', 'mail', 'chart', 'users', 'package']]
  ];

  iconSets.forEach(([selector, iconNames]) => {
    document.querySelectorAll(selector).forEach((item, index) => {
      const icon = item.querySelector(':scope > svg');
      if (icon) icon.innerHTML = icons[iconNames[index]] || icons.document;
    });
  });

  document.querySelectorAll('#tasks .i-task-summary > li, .i-full-task-list > li').forEach((item) => {
    const text = item.textContent.trim();
    const questionEnd = text.indexOf('?');

    if (questionEnd < 0) return;

    const question = text.slice(0, questionEnd + 1);
    const answer = text.slice(questionEnd + 1).trim();
    if (!answer) return;

    item.childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) node.remove();
    });

    const copy = document.createElement('div');
    copy.className = 'i-task-card-copy';

    const heading = document.createElement('h4');
    heading.textContent = question;

    const description = document.createElement('p');
    description.textContent = answer;

    copy.append(heading, description);
    item.append(copy);
  });
});
